import request from '../util/http'

export const login = (data) =>
  request({
    url: '/zcjf/base/user/login',
    method: 'post',
    data,
  })

export const lairPasslogin = (data) =>
  request({
    url: '/zcjf/base/user/lairPasslogin',
    method: 'post',
    data,
  })

export const sendCode = (data) =>
  request({
    url: '/zcjf/base/code/sendLoginCode',
    method: 'post',
    data,
  })

export function getInfo() {
  return request({
    url: '/zcjf/base/user/getUserInfo',
    method: 'get',
  })
}

export function logout() {
  return request({
    url: '/zcjf/base/user/logout',
    method: 'post',
  })
}

export function getUserRes() {
  return request({
    url: '/zcjf/base/personal/profile/info',
    method: 'get',
  })
}

export function updateUserRes(data) {
  return request({
    url: '/zcjf/base/personal/profile/update',
    method: 'post',
    data,
  })
}

export function shopLogin() {
  return request({
    url: '/zcjf/base/user/shopLogin',
    method: 'post',
  })
}

// 用户反馈信息登记
export const submitPerformance = (data) =>
  request({
    url: '/zcjf/base/userFeedback/addUserFeedback',
    method: 'post',
    data,
  })

// 查询用户反馈信息
export const queryUserFeedbackByOrderId = (data) =>
  request({
    url: '/zcjf/base/userFeedback/queryUserFeedbackByOrderId',
    method: 'post',
    data,
  })